// extracted by mini-css-extract-plugin
export default {"counter":"styles_counter__6fB7O","hover":"styles_hover__7+erP"};